import React from 'react';

export const gvl_airplane = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M8 22h2l5-8.5h5.5c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5H15L10 2H8l2.5 8.5H5L3.5 8H2l1 4-1 4h1.5L5 13.5h5.5L8 22z" />
  </svg>
);

export const gvl_animal = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      d="M19.725 9.159l-2.99-2.652-.126-1.177c0-.29-.694-.439-.973-.439-.141 0 .091-.1 0 0L11.89 8.365l-3.464.232c-.687 0-1.915.227-2.289.826l-2.274 2.555c-.333.472.327 1.7.781 2.056.344.252.381-.219 1.492-.174v5.455h8.137l.156-5.763c0-.556.3-.79.688-1.178l1.24-1.515 1.322 1.275s.659.72 1.228.327 1.644-1.417 1.636-2.054a4.619 4.619 0 00-.818-1.248z"
      opacity={0.3}
    />
    <path d="M14.112 19.1v-5.529a2.888 2.888 0 01.734-1.619l1.559-1.619 1.559 1.619c.092.1.275.381.55.381.092 0 1.742-1.333 1.742-2 0-.286-.55-.762-.734-.952l-3.023-2.952v-.762a1.015 1.015 0 00-.734-.762l-3.759 3.9H8.612c-.734 0-1.834 0-2.2.571L4.12 11.952c-.367.476.275 1.238.734 1.619.183.1.275.19.367.19s.183-.1.367-.19l.734-.476v6h3.026v-3.9h1.924v3.9h2.84m1.834 1.9H4.303v-5.424a2.652 2.652 0 01-.734-.381c-1.557-1.238-2.017-2.952-1.1-4.19l.092-.1.092-.1L4.67 8.238C5.587 6.9 7.329 6.9 8.338 6.9h2.659C14.115 3.567 14.756 3 14.756 3h.825a1.8 1.8 0 011.009.286 2.216 2.216 0 01.734.571 2.536 2.536 0 01.825 1.81l2.476 2.381.092.1.092.1.092.1a3.082 3.082 0 011.1 2.1 4.489 4.489 0 01-2.2 3.429 2.66 2.66 0 01-1.375.476 2.742 2.742 0 01-1.65-.667l-.183-.186-.183-.19-.183.19c-.092.1-.183.19-.183.286V21z" />
  </svg>
);

export function gvl_dog(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M21.5 7.9L20 5.3a3.493 3.493 0 00-3-1.8 2.822 2.822 0 00-1.5.4 5.954 5.954 0 00-2.7-.6h-2a6.6 6.6 0 00-2.7.6 4.013 4.013 0 00-1.5-.3 3.409 3.409 0 00-3 1.8L2.5 7.9a3.631 3.631 0 001.2 4.8c.2.1.3.2.5.2a6.72 6.72 0 005.3 6.2 2.1 2.1 0 00.4 1.1 2.209 2.209 0 002 .8 2.481 2.481 0 002-.8 1.5 1.5 0 00.4-1.1 6.918 6.918 0 005.3-6.2c.2-.1.3-.1.5-.2a3.43 3.43 0 001.4-4.8zm-8.3 11.8c-.2.3-.6.4-1.2.4a1.691 1.691 0 01-1.2-.4c-.1-.1-.1-.2-.2-.3h2.8c0 .1-.1.2-.2.3zm6.1-8.7c-.1 0-.1.1-.2.1l-1.2.5-.1 1.3a5.181 5.181 0 01-1.6 3.3 5.069 5.069 0 01-3.3 1.3h-.5v-1.1a1.069 1.069 0 001-.9c0-.6-.7-1-1.5-1s-1.5.4-1.5 1a1.069 1.069 0 001 .9v1.1H11a5.069 5.069 0 01-3.3-1.3 5.181 5.181 0 01-1.6-3.3L6 11.6l-1.2-.5c.1-.1 0-.1-.1-.1a1.577 1.577 0 01-.5-2.1l1.5-2.6a1.306 1.306 0 011.2-.7 1.268 1.268 0 01.6.1l.8.4.9-.4a4.058 4.058 0 011.9-.4h2a4.333 4.333 0 011.9.4l.9.4.8-.4a1.268 1.268 0 01.6-.1 1.387 1.387 0 011.2.7L20 8.9a1.9 1.9 0 01-.7 2.1zm-3.9-.1c-1 0-1.8 1.1-1.9 1.2l.8.6c.3-.3.8-.8 1.1-.8.4 0 .9.5 1.1.8l.8-.6a2.6 2.6 0 00-1.9-1.2zm-6.8 0c-1 0-1.8 1.1-1.9 1.2l.8.6c.3-.3.8-.8 1.1-.8.4 0 .9.5 1.1.8l.8-.6a2.6 2.6 0 00-1.9-1.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export function gvl_cat(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M5.6 12.7l.8.6C6.7 12.9 7.5 12 8 12s1.3.9 1.6 1.3l.8-.6C10.3 12.6 9.2 11 8 11s-2.3 1.6-2.4 1.7zM16 11c-1.2 0-2.3 1.5-2.4 1.7l.8.6c.3-.4 1-1.3 1.6-1.3.5 0 1.3.9 1.6 1.3l.8-.6c-.1-.1-1.2-1.7-2.4-1.7zM4.4 14.2c-.2-.2-.3-.4-.4-.5A10.288 10.288 0 015.5 11l.5-.6v-.7s0-.9.1-1.9a13.885 13.885 0 01.3-1.7 6.4 6.4 0 011.1.6 6.326 6.326 0 011.2.9l.8.7 1-.3a4.636 4.636 0 011.4-.2 8.794 8.794 0 011.4.2l1 .3.8-.7s.6-.4 1.3-.9a6.4 6.4 0 011.1-.6 10.926 10.926 0 01.3 1.7 10.886 10.886 0 01.2 1.9v.6l.4.5a12.037 12.037 0 011.6 2.8 2.186 2.186 0 00-.3.5 7.572 7.572 0 011.8.9 2.774 2.774 0 00.6-1.3c0-1-1.4-3.2-2-4.1 0 0 0-5.3-1.5-5.7h-.4C16.5 4 14 6 14 6a7.991 7.991 0 00-2-.3 7.991 7.991 0 00-2 .3S7.4 4 5.9 4h-.4C4 4.4 4 9.7 4 9.7c-.7.8-2 3.1-2 4.1a3.267 3.267 0 00.6 1.3 5.076 5.076 0 011.8-.9zm8.1 2.8v-1.1a1.5 1.5 0 001-1.1c0-.4-.7-.4-1.5-.4s-1.5 0-1.5.4a1.5 1.5 0 001 1.1V17zm9.6-.4a10.611 10.611 0 00-3.4-1.6 11.366 11.366 0 00-3.7-.3l.1.9v.1a9.772 9.772 0 013 1.1 10.039 10.039 0 012.3 2.3l.8-.6a12.285 12.285 0 00-2.5-2.6h-.1a8.469 8.469 0 013 1.5zm-5.7.4a9.233 9.233 0 01-4.4 1 10.987 10.987 0 01-4.4-1A3.638 3.638 0 006 18.4a12.1 12.1 0 006 1.6 11.423 11.423 0 005.9-1.6 2.915 2.915 0 00-1.5-1.4zm-7.5-1.4l.1-.9a11.6 11.6 0 00-3.7.3 15.046 15.046 0 00-3.4 1.6l.6.8a14.02 14.02 0 013-1.5.1.1 0 00-.1.1 11.849 11.849 0 00-2.5 2.5l.8.6A8.392 8.392 0 016 16.8a6.864 6.864 0 012.9-1.2z"
        fill="currentColor"
      />
    </svg>
  );
}

export const gvl_arrows_opposite = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M6.926 11.444L2 16.383l4.926 4.938v-3.7H15v-2.473H6.926zM22 7.494l-4.926-4.938v3.7H9v2.469h8.074v3.7z" />
  </svg>
);

export const gvl_check = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

export const gvl_credit_card = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M20,4H4A1.985,1.985,0,0,0,2.01,6L2,18a1.993,1.993,0,0,0,2,2H20a1.993,1.993,0,0,0,2-2V6A1.993,1.993,0,0,0,20,4Zm0,14H4V12H20ZM20,8H4V6H20Z" />
  </svg>
);

export const gvl_cross = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M19 3H5a2 2 0 00-1.99 2L3 19a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2V5a2.006 2.006 0 00-2-2zm0 16H5V5h14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z" />
  </svg>
);

export const gvl_document = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M5.991 22A2 2 0 014 20V4a2.007 2.007 0 012-2h8l6 6v12a2.006 2.006 0 01-2 2zM6 20h12V9h-5V4H6zm2-2v-2h8v2zm0-4v-2h8v2z" />
  </svg>
);

export const gvl_double_check = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12zM.41 13.41L6 19l1.41-1.41L1.83 12z" />
  </svg>
);

export const gvl_download = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M19 12v7H5v-7H3v7a2.006 2.006 0 002 2h14a2.006 2.006 0 002-2v-7zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />
  </svg>
);

export const gvl_edit = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M5 18.08V19h.92l9.06-9.06-.92-.92z" opacity={0.3} />
    <path d="M3 21v-3.749l11.06-11.06 3.75 3.75L6.75 21zm2-2.92V19h.92l9.061-9.059-.92-.92zM15.131 5.12l1.829-1.829a.981.981 0 01.7-.29.979.979 0 01.71.29l2.34 2.34a.994.994 0 010 1.409l-1.831 1.831z" />
  </svg>
);

export const gvl_help = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M11 18h2v-2h-2zm1-16a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8.011 8.011 0 01-8 8zm0-14a4 4 0 00-4 4h2a2 2 0 014 0c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5a4 4 0 00-4-4z" />
  </svg>
);

export const gvl_home = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M12 3L2 12h3v8h6v-6h2v6h6v-8h3zm5 15h-2v-6H9v6H7v-7.81l5-4.5 5 4.5z" />
    <path d="M7 10.19V18h2v-6h6v6h2v-7.81l-5-4.5z" opacity={0.3} />
  </svg>
);

export const gvl_intercom_filled = props => (
  <svg width="1em" height="1em" viewBox="0 0 30 34" {...props}>
    <path d="M26.357 0H3.643A3.621 3.621 0 000 3.605v23.119a3.621 3.621 0 003.643 3.606h16.864L30 33.999V3.605A3.621 3.621 0 0026.357 0zm-1.564 23.713s-5.014 2.779-9.9 2.779a21.8 21.8 0 01-9.6-2.779s-1.2-.594-1.2-1.315a1.278 1.278 0 011.2-1.315c.814 0 4.736 3.139 9.6 3.139s9.129-3.139 9.9-3.139 1.114.53 1.114 1.315-1.114 1.315-1.114 1.315z" />
  </svg>
);

export const gvl_logout = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M9.857 15.977l1.539 1.539 5.459-5.459-5.458-5.458-1.54 1.539 2.817 2.828H2.117v2.183h10.557zM21.768 2.232H2.117v6.55H4.3V4.415h15.285V19.7H4.3v-4.368H2.117v6.55h19.651z" />
  </svg>
);

export const gvl_message = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M4 4h16v12H5.17L4 17.17V4m0-2a2 2 0 00-1.99 2L2 22l4-4h14a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zm2 10h12v2H6zm0-3h12v2H6zm0-3h12v2H6z" />
  </svg>
);

export const gvl_organization = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M2 21V3h10v4h10v14zm10-2h8V9h-8v2h2v2h-2v2h2v2h-2zm-4 0h2v-2H8zm-4 0h2v-2H4zm4-4h2v-2H8zm-4 0h2v-2H4zm4-4h2V9H8zm-4 0h2V9H4zm4-4h2V5H8zM4 7h2V5H4zm12 10v-2h2v2zm0-4v-2h2v2z" />
  </svg>
);

export const gvl_person_circle_large = props => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" {...props}>
    <path
      d="M20 40A20 20 0 015.858 5.858a20 20 0 0128.284 28.284A19.869 19.869 0 0120 40zm0-16.625c-3.036 0-6.525 1.452-6.75 2.263v1.113h13.5v-1.126c-.227-.807-3.717-2.25-6.75-2.25zm0-10.125a2.25 2.25 0 102.251 2.25A2.253 2.253 0 0020 13.25z"
      opacity={0.3}
    />
    <path d="M11 29v-3.374c0-2.992 6-4.5 9-4.5s9 1.508 9 4.5V29zm2.25-3.363v1.114h13.5v-1.125c-.225-.8-3.712-2.251-6.75-2.251s-6.524 1.451-6.75 2.261zm2.25-10.136a4.5 4.5 0 014.5-4.5 4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5 4.5 4.5 0 01-4.5-4.501zm2.25 0a2.257 2.257 0 002.251 2.249 2.256 2.256 0 002.25-2.249 2.256 2.256 0 00-2.25-2.25A2.257 2.257 0 0017.75 15.5z" />
  </svg>
);

export const gvl_person = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M12 5.138A2.362 2.362 0 119.637 7.5 2.362 2.362 0 0112 5.138m0 10.125c3.341 0 6.863 1.643 6.863 2.363v1.238H5.138v-1.239c0-.72 3.521-2.363 6.862-2.363M12 3a4.5 4.5 0 104.5 4.5A4.5 4.5 0 0012 3zm0 10.125c-3 0-9 1.507-9 4.5V21h18v-3.375c0-2.993-6-4.5-9-4.5z" />
  </svg>
);

export const gvl_pharma = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      d="M5.11 19h13.78l-1.79-5.37-.21-.63.21-.63L18.89 7H5.11l1.79 5.37.21.63-.21.63zM8 12h3V9h2v3h3v2h-3v3h-2v-3H8z"
      opacity={0.3}
    />
    <path d="M3 21v-2l2-6-2-6V5h12.689l1.461-4 2.35.859-1.14 3.14H21v2l-2 6 2 6v2zm3.9-8.63l.21.63-.21.63L5.11 19h13.78l-1.79-5.37-.21-.63.21-.63L18.89 7H5.11zM11 17v-3H8v-2h3V9h2v3h3v2h-3v3z" />
  </svg>
);

export const gvl_phone = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      d="M15.21 18.21l1.19-1.19a14.263 14.263 0 002.6.45h.01v1.49a14.457 14.457 0 01-3.8-.75zM5.04 5h1.5a12.529 12.529 0 00.449 2.6l-1.2 1.2A15.466 15.466 0 015.04 5z"
      opacity={0.3}
    />
    <path d="M20 21a1 1 0 001-1v-3.49a1 1 0 00-1-1 11.407 11.407 0 01-3.57-.57.839.839 0 00-.31-.05 1.024 1.024 0 00-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2a1 1 0 00.25-1.02A11.36 11.36 0 018.5 4a1 1 0 00-1-1H4a1 1 0 00-1 1 17 17 0 0017 17zm-3.6-3.98a12.753 12.753 0 002.6.45v1.49a15.426 15.426 0 01-3.8-.75zM5.03 5h1.5a13 13 0 00.46 2.59l-1.2 1.2A14.825 14.825 0 015.03 5z" />
  </svg>
);

export const gvl_plus = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" />
  </svg>
);

export const gvl_records = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M4 6H2v14a2.006 2.006 0 002 2h14v-2H4zm16-4H8a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h12a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zm0 14H8V4h12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z" />
  </svg>
);

export const gvl_refresh = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M12 4V1L8 5l4 4V6a6 6 0 016 6 5.87 5.87 0 01-.7 2.8l1.46 1.46A7.986 7.986 0 0012 4zm0 14a6 6 0 01-6-6 5.87 5.87 0 01.7-2.8L5.24 7.74A7.986 7.986 0 0012 20v3l4-4-4-4z" />
  </svg>
);

export const gvl_save = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path
      d="M5 5v14h14V7.83L16.17 5zm7 13a3 3 0 113-3 3 3 0 01-3 3zm3-8H6V6h9z"
      opacity={0.3}
    />
    <path d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2.006 2.006 0 002-2V7zm2 16H5V5h11.17L19 7.83zm-7-7a3 3 0 103 3 3 3 0 00-3-3zM6 6h9v4H6z" />
  </svg>
);

export const gvl_search = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M15.5 14h-.79l-.28-.27a6.51 6.51 0 10-.7.7l.27.28v.79l5 4.99L20.49 19zm-6 0A4.5 4.5 0 1114 9.5 4.494 4.494 0 019.5 14z" />
  </svg>
);

export const gvl_sign_dotted = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M4 16.859v1.145h1.145l11.276-11.28-1.145-1.145z" opacity={0.3} />
    <path d="M19 21a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1zm-4 0a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1zm-4 0a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1zm-4 0a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1zm-4 0a1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1zm0-2v-3.749L15 3l1 1 2-2 2 2-2 2 1 1L6.75 19zm2-2.92V17h.92L16 7l-1-1z" />
  </svg>
);

export const gvl_syringe = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M6.66 6.31a1 1 0 00-.16-.12.89.89 0 01-.51-1 .56.56 0 01.7-.39 2.36 2.36 0 01.81.47 4.3 4.3 0 00.79.55l1.65-2.33c-.12-.1-.22-.18-.32-.28A.42.42 0 019.48 3a2 2 0 01-.14-1.21A3 3 0 019.89.76a1.9 1.9 0 012.36-.07 7.09 7.09 0 01.74.59l.88.58.74.56a3.53 3.53 0 00.32.21l.14.08.77.61.14.1c.26.16.51.34.76.53a2.26 2.26 0 01.26.42 1.49 1.49 0 01.06 1.51A1.91 1.91 0 0115.82 7a4 4 0 01-1.19-.09c-.07 0-.12-.1-.19-.15l-1.65 2.33c.26.16.54.33.81.53a2.27 2.27 0 01.62.53.68.68 0 010 .76.6.6 0 01-.63.25.67.67 0 01-.59-.26.8.8 0 00-.21-.15 4.12 4.12 0 00-.28.31c-.29.39-.57.78-.85 1.18s-.52.81-.81 1.2c-.38.54-.8 1.06-1.19 1.59-.22.31-.41.66-.64 1-.46.63-.92 1.25-1.41 1.85a2.53 2.53 0 01-1.8.93 2 2 0 01-1.21-.21c-.27-.17-.56-.3-.88-.47a1.29 1.29 0 00-.16.17c-.33.44-.65.88-1 1.33-.18.27-.33.55-.52.81a.74.74 0 01-1 .14.57.57 0 01-.15-.16.62.62 0 010-.68 11.25 11.25 0 011.27-1.8 5.41 5.41 0 00.46-.61L2.31 17a.34.34 0 00-.09-.08c-.38-.16-.53-.54-.7-.84A3.05 3.05 0 011.26 15a2.66 2.66 0 01.67-2c.28-.39.52-.82.8-1.21s.76-1 1.13-1.48c.23-.33.43-.68.66-1 .41-.57.86-1.12 1.26-1.69.31-.39.58-.85.88-1.31zm.54 1.63c.15.14.27.26.41.37s.2.09.28.15a5.52 5.52 0 00.82.62 2 2 0 01.55.45.53.53 0 01.08.74.72.72 0 01-.89.23l-.8-.5a.69.69 0 00-.13-.05 1.51 1.51 0 01-.26-.18L7 9.49l-.26-.17-.28-.27-.34.47a2.22 2.22 0 01.34.22c.3.22.59.45.89.69h.07l.29.21c.09.07.15.16.25.19.26.06.33.26.38.47s-.1.79-.35.82a1.21 1.21 0 01-.9-.23c-.27-.21-.53-.44-.8-.64s-.64-.42-1-.63a.87.87 0 00-.14.27.3.3 0 000 .24c.23.19.48.35.71.52l1.12.8a.5.5 0 01.22.55.64.64 0 01-.42.55.58.58 0 01-.7-.12 5.17 5.17 0 00-.75-.55h-.09L5 12.72l-.81-.65-.19.28.49.41a.94.94 0 00.22.12L5 13a6 6 0 00.85.65.73.73 0 01.4.5c.11.4-.15.87-.5.84a2.2 2.2 0 01-.75-.25 3.12 3.12 0 01-.47-.34l-.19-.14L4 14c-.08-.06-.18-.09-.23-.16a.63.63 0 00-.5-.3c-.13.18-.26.34-.38.52a1.48 1.48 0 00-.26.46 1.39 1.39 0 00.8 1.54 1.1 1.1 0 01.14.09l.8.64.42.31a1.57 1.57 0 001 .32 1.41 1.41 0 00.83-.42c.33-.41.67-.82 1-1.25.43-.6.84-1.23 1.27-1.84.16-.23.37-.43.53-.67.34-.49.65-1 1-1.49s.52-.67.78-1 .36-.5.54-.73L7.78 7.14zm3.85-3.61L9.39 6.61l2.34 1.69L13.32 6zm4.3 1.38c.26 0 .64-.42.51-.6a3.39 3.39 0 00-.51-.49l-.26-.17-.27-.23-.82-.55c-.17-.11-.34-.22-.51-.35l-.87-.7-.13-.06-.24-.15-.39-.28-.23-.13a2.45 2.45 0 00-.44-.3.34.34 0 00-.45.18.14.14 0 000 .07c-.12.36-.07.5.18.6a1.85 1.85 0 01.27.19c.09.07.17.15.27.22l.85.55c.27.2.53.43.8.64.11.09.25.14.37.23l.81.63h.12l.25.18.66.5z" />
  </svg>
);

export const gvl_upload = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M5 21a2.006 2.006 0 01-2-2v-7h2v7h14v-7h2v7a2.006 2.006 0 01-2 2zm6-4.5V6.83L8.41 9.41 7 8l5-5 5 5-1.41 1.41L13 6.83v9.67z" />
  </svg>
);

export const gvl_x = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z" />
  </svg>
);

export const gvl_arrow_right_circle = props => (
  <svg viewBox="0 0 13 13" width="1em" height="1em" {...props}>
    <path d="M6.48 0a6.5 6.5 0 11-6.5 6.5A6.5 6.5 0 016.48 0zm-.74 3.76l2 1.9h-4.8a.63.63 0 00-.63.63v.42a.63.63 0 00.63.68h4.78l-2 1.9a.63.63 0 000 .89l.29.28a.63.63 0 00.89 0l3.48-3.47a.63.63 0 000-.89L6.91 2.57a.64.64 0 00-.89 0l-.29.29a.64.64 0 000 .9z" />
  </svg>
);

export const gvl_arrow_left_circle = props => (
  <svg viewBox="0 0 13 13" width="1em" height="1em" {...props}>
    <g>
      <circle cx={6.5} cy={6.5} r={6.5} />
      <path
        fill="#fff"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        d="M9.65 4.5v2H4.12l1.5-1.8-.59-.7-2.52 3 2.53 3 .59-.7-1.5-1.8h6.38v-3z"
      />
    </g>
  </svg>
);

export const gvl_archived = props => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    <path d="M16 0a16 16 0 1016 16A16 16 0 0016 0zm10.13 21.88a1.76 1.76 0 01-2 1.29c-5.25-.05-10.49-.06-15.73 0-1.34 0-1.72-.48-1.7-1.75.06-4.24.08-8.48 0-12.72 0-.63.06-1.44.73-1.73a3.56 3.56 0 011.34-.12h1.58a11.79 11.79 0 013.7.4 3.48 3.48 0 011.84 1.22c.12.19.21.41.33.6a1.36 1.36 0 001.16.65 42.41 42.41 0 005.52.09c.73 0 1.71-.24 2.32.25a1.76 1.76 0 01.51 1.5v1c0 .35 0 .81.08 1a1.61 1.61 0 00.49 0h1.25c1.62 0 1.81.25 1.24 1.71-.85 2.16-1.79 4.36-2.66 6.61z" />
    <path d="M17.39 11.25c-.66 0-1.77.18-1.9-.78-.36-2.32-3.67-2.09-6-2-1 0-1 .22-1 .93s-.05 5.53-.05 8.29l.38.08c.44-1 .95-2.06 1.31-3.13a1.54 1.54 0 011.75-1.16h12.05v-2.19c-2.27 0-4.41.06-6.54-.04z" />
  </svg>
);

export const material_open_in_new = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
  </svg>
);
